function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Country_or_International_ic",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M102.24 20.22C124.33 39.9 140 66.54 140 96c0 29.13-16.1 56.17-37.76 75.78M89.76 20.22C67.67 39.9 52 66.54 52 96c0 29.13 16.1 56.17 37.76 75.78M20 96h152M96 172V20",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M154.27 47.19C137 59.61 117.8 68 96 68c-21.52 0-40.92-8.44-58.26-20.81M37.76 144.81C55 132.39 74.22 124 96 124c21.52 0 40.92 8.44 58.26 20.81",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 96,
  r: 76,
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h192v192H0z"
}));

var SvgCountryOrInternational = function SvgCountryOrInternational(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgCountryOrInternational;